import { atom } from "recoil";

export const isViewportTopState = atom({
  default: true,
  key: "isViewportTopState",
});
